import React from "react";
import { Helmet } from "react-helmet";
import "./LegalPage.css";
import { LegalSection } from "./legalPagesData";

interface LegalPageProps {
  title: string;
  description: React.ReactNode;
  effectiveDate: string;
  sections: LegalSection[];
  domainDetails?: DomainDetails;
}

export interface DomainDetails {
  companyName?: string;
  domainName?: string;
  email?: string;
  phone?: string;
  address?: string;
}

const LegalPage: React.FC<LegalPageProps> = ({
  title,
  description,
  effectiveDate,
  sections,
}) => {
  return (
    <main className="legal-page">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <section className="legal-page__hero">
        <div className="legal-page__container">
          <h1>{title}</h1>
          <p className="legal-page__subtitle">Native App</p>
          <p className="legal-page__description">{description}</p>
          <p className="legal-page__date">Effective date: {effectiveDate}</p>
        </div>
      </section>

      <section className="legal-page__container legal-page__content">
        <div className="legal-page__card">
          {sections.map((section, index) => (
            <article className="legal-page__section" key={section.title}>
              <div className="legal-page__section-header">
                <span className="legal-page__section-number">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h2>{section.title}</h2>
              </div>
              <div className="legal-page__section-body">
                {section.body?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {section.items && (
                  <ul>
                    {section.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
        </div>

    
      </section>
    </main>
  );
};

export default LegalPage;
